<template>
  <div class="alert-detail">
    <v-alert type="success" v-if="status === 'success'">
      {{successText}}
    </v-alert>
    <v-alert type="error" v-if="status === 'error'">
     {{errorText}}
    </v-alert>
  </div>
</template>

<script>

export default {
  name: 'SaveAlert',
  props:{
    status: String,
    successText: String,
    errorText: String
  },
}
</script>
